import React, { useEffect, useState } from "react";
import { ConfigProvider, Skeleton, Button, Typography } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import Menus from "./menus";
import { UserSlot, AdminSlot, ThemeSlot } from "./slot";
import { getUiConfig } from "@/utils";
import styles from "./main.module.css";

export default function MainLayout({ siteInfo, isInit, children }) {
  const [collapsed, setCollapsed] = useState<boolean>(false); // 菜单导航折叠状态
  const { uiHideNav, uiHideMenu } = getUiConfig();

  const logo =
    siteInfo.appLogo || `${import.meta.env.BASE_URL}default-logo.png`;

  // 菜单展开收起控制
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  // 设置网页标题
  useEffect(() => {
    if (siteInfo.appName) {
      document.title = siteInfo.appName;
    }
  }, [siteInfo.appName]);

  // 设置favicon
  useEffect(() => {
    const favicon = document.querySelector("link[rel='icon']");
    if (favicon instanceof HTMLLinkElement) {
      favicon.href = logo;
    }
  }, [logo]);

  if (isInit) {
    // 渲染骨架屏
    return (
      <div
        className={`${styles.layout} ${uiHideNav ? styles.uiHideNav : null} ${uiHideMenu ? styles.uiHideMenu : null}`}
      >
        {/* 顶部导航 */}
        <div className={styles.header}>
          <div className={styles.logo}>
            <Skeleton.Avatar />
            <Skeleton.Input />
          </div>
          <div className={styles.menu} />
          <div className={styles.slot}>
            <Skeleton.Avatar />
          </div>
        </div>
        {/* 左侧导航 */}
        <nav className={styles.nav}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              padding: "16px",
            }}
          >
            <Skeleton.Input />
            <Skeleton.Input style={{ marginLeft: "24px" }} />
            <Skeleton.Input style={{ marginLeft: "24px" }} />
            <Skeleton.Input style={{ marginLeft: "24px" }} />
            <Skeleton.Input />
            <Skeleton.Input />
            <Skeleton.Input style={{ marginLeft: "24px" }} />
          </div>
        </nav>
        {/* 内容区域 */}
        <main className={styles.main}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              padding: "16px",
            }}
          >
            <Skeleton active paragraph={{ rows: 3 }} />
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        </main>
      </div>
    );
  }

  return (
    <div
      className={`${styles.layout} ${uiHideNav ? styles.uiHideNav : null} ${uiHideMenu ? styles.uiHideMenu : null}`}
    >
      {/* 顶部导航和左侧导航属于框架层面的内容, 尺寸固定 */}
      {/* 顶部导航 */}
      <ConfigProvider theme={{ token: { fontSize: 14 } }}>
        <div className={styles.header}>
          <div
            className={styles.logo}
            onClick={() => {
              location.href = "/";
            }}
          >
            <img src={logo} alt={siteInfo.appName} />
            <Typography.Title level={4} style={{ margin: 0 }}>
              {siteInfo.appName}
            </Typography.Title>
          </div>
          <div className={styles.menu} />
          <div className={styles.slot}>
            <UserSlot />
            <ThemeSlot />
            <AdminSlot />
          </div>
        </div>
        {/* 左侧导航 */}
        <nav
          className={`${styles.nav}${collapsed ? ` ${styles.collapsed}` : ""}`}
        >
          <div className={styles.menuWrapper}>
            <Menus collapsed={collapsed} />
          </div>
          <div className={styles.footer}>
            <Button type="text" onClick={toggleCollapsed}>
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </Button>
          </div>
        </nav>
      </ConfigProvider>
      {/* 内容区域 */}
      <main className={styles.main}>
        <div className={styles.page}>
          {/* 由于面包屑在UI上很可能需要在右侧继续插入内容，因此应该是具体页面级别的，不在容器层注入 */}
          {/* 目前只在lowcode页面中注入面包屑 */}
          {children}
        </div>
      </main>
    </div>
  );
}
